import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';

import agm from '../../services/agm';
import Alerts from '../../utils/alerts';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Card
} from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 340,
    },
}));

const Create = ({ item, open, closeCreation, createValues, dependencies }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    const requestName = async (value, values) => {
        await agm.get('/unidades/' + value, {}, {}).then((response) => {
            if (!response.data.error) {
                var units = response.data;
                values.name = '';
                values.unit = '';
                values.type = '';
                values.controller = '';
                values.supervisor = '';
                values.engineer = '';
                if (units.length > 0) {
                    if (units[0].ativa) {
                        values.name = units[0].nome;
                        values.unit = units[0].id;
                        values.type = (units[0].tipo) ? units[0].tipo.nome : 'Não Definido';
                        values.controller = units[0].gerenciadora.nome;
                        values.supervisor = units[0].fiscal;
                        values.engineer = units[0].engenheiro.nome;

                    } else {
                        setMessage({
                            error: true,
                            warn: true,
                            message: "Unidade está inativa.",
                            detail: "Unidade " + value + ' - ' + units[0].nome + " existe mas está inativa. Acesse tela de unidades e ative a unidade."
                        });
                        setOpenAlert(true);
                    }
                } else {
                    setMessage({
                        error: true,
                        message: "Unidade Centro de Custo " + value + " não foi encontrada.",
                        detail: "Tente novamente.",
                    });
                    setOpenAlert(true);
                }
            } else {
                console.debug(response);
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    const handleAperture = async (value, values) => {
        dependencies.symptomes.map(function (symptom) {
            if (symptom.id === values.symptom) {
                var estimativa = getEstimatedDays(symptom);
                if (estimativa > 0) {
                    var atendance = getEstimatedDaysAtendance(symptom);
                    var conclusion = getestimatedDaysConclusion(symptom);
                    values.dateFirstAtend = moment((value)).add(atendance, 'days');
                    values.dateConclusion = moment((value)).add(atendance + conclusion, 'days');
                }
            }
        });
    }

    const handleSymptom = async (event, values) => {
        dependencies.symptomes.map(function (symptom) {
            if (event.target.value === symptom.id) {
                var estimativa = getEstimatedDays(symptom);
                if (estimativa > 0) {
                    var atendance = getEstimatedDaysAtendance(symptom);
                    var conclusion = getestimatedDaysConclusion(symptom);
                    values.dateFirstAtend = moment(values.dateAperture).add(atendance, 'days');
                    values.dateConclusion = moment(values.dateAperture).add(atendance + conclusion, 'days');
                }
            }
        });
    }

    const getEstimatedDaysAtendance = (symptom) => {
        if (symptom.slaAtendimento) {
            var atendimento = symptom.vlrAtendimento;
            if (symptom.slaAtendimento == 'Mês') {
                atendimento = (symptom.vlrAtendimento * 30);
            }
            return atendimento;
        }
        return 0;
    }

    const getestimatedDaysConclusion = (symptom) => {
        if (symptom.slaConclusao) {
            var conclusao = symptom.vlrConclusao;
            if (symptom.slaConclusao == 'Mês') {
                conclusao = (symptom.vlrConclusao * 30);
            }
            return conclusao;
        }
        return 0;
    }

    const getEstimatedDays = (symptom) => {
        var conclusao = getestimatedDaysConclusion(symptom);
        var atendimento = getEstimatedDaysAtendance(symptom);
        var estimativa = (conclusao + atendimento);
        return estimativa;
    }

    const getSymptomName = (symptom) => {
        var estimativa = getEstimatedDays(symptom);
        if (estimativa > 0) {
            if (estimativa > 1) {
                estimativa += ' Dias';
            } else {
                estimativa += ' Dia';
            }
            return symptom.nome + ' [ ' + estimativa + ' ]';
        } else {
            return symptom.nome + ' [ Sem Estimativa ]';
        }
    }

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />


            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Nova Ocorrência
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                company: Yup.string().required('A seleção da empresa é obrigatória'),
                                contract: Yup.string().required('A seleção do contrato é obrigatória'),
                                dateAperture: Yup.date().required('A data de abertura da ocorrência é obrigatória'),
                                number: Yup.string().max(25).required('O número da ocorrência é obrigatório'),
                                code: Yup.string().max(20).required('A seleção da unidade é obrigatória'),
                                name: Yup.string().required('O centro de custo não foi encontrado'),
                                type: Yup.string().required('O centro de custo não foi encontrado'),
                                companyStatus: Yup.string().required('A seleção do tipo de ocorrência é obrigatória'),
                                category: Yup.string().required('A seleção da categoria da ocorrência é obrigatória'),
                                atendType: Yup.string().required('A seleção de tipo de atendimento é obrigatória'),
                                ocorrenceStatus: Yup.string().required('A seleção do status da ocorrência é obrigatória'),
                                occurrenceType: Yup.string().required('A seleção do tipo da ocorrência é obrigatória'),
                                invoiceType: Yup.string().required('A seleção do tipo de nota é obrigatória')
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Box>

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >
                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="normal">
                                                <InputLabel shrink htmlFor="company" required >Cliente</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.company && errors.company)}
                                                    helperText={touched.company && errors.company}
                                                    value={values.company}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Cliente"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'company',
                                                        id: 'company',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.companies.map((company) => (
                                                        <MenuItem key={company.id} value={company.id}>{company.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={5}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="normal">
                                                <InputLabel shrink htmlFor="contract" required >Contrato</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.contract && errors.contract)}
                                                    helperText={touched.contract && errors.contract}
                                                    value={values.contract}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Contrato"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'contract',
                                                        id: 'contract',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.contracts.map((contract) => (
                                                        <MenuItem key={contract.id} value={contract.id}>{contract.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                error={Boolean(touched.dateAperture && errors.dateAperture)}
                                                required
                                                cancelLabel="Cancelar"
                                                margin="normal"
                                                inputVariant="outlined"
                                                id="dateAperture"
                                                label="Data de Abertura"
                                                format="DD/MM/YYYY"
                                                name="dateAperture"
                                                value={values.dateAperture}
                                                onBlur={handleBlur}
                                                onChange={value => {
                                                    handleAperture(value, values);
                                                    setFieldValue("dateAperture", value);
                                                }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>


                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.number && errors.number)}
                                                fullWidth
                                                required
                                                label="Número"
                                                margin="none"
                                                name="number"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.number}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.code && errors.code)}
                                                fullWidth
                                                required
                                                label="Centro de Custo"
                                                margin="none"
                                                name="code"
                                                onBlur={e => {
                                                    handleBlur(e);
                                                    requestName(e.currentTarget.value, values);
                                                }}
                                                onChange={handleChange}
                                                value={values.code}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={5}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.name && errors.name)}
                                                fullWidth
                                                label="Unidade"
                                                margin="none"
                                                name="name"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.name}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.type && errors.type)}
                                                fullWidth
                                                label="Tipo de Unidade"
                                                margin="none"
                                                id="type"
                                                name="type"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.type}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.engineer && errors.engineer)}
                                                fullWidth
                                                label="Engenheiro Responsável"
                                                margin="none"
                                                id="engineer"
                                                name="engineer"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.engineer}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.controller && errors.controller)}
                                                fullWidth
                                                label="Gerenciadora"
                                                margin="none"
                                                id="controller"
                                                name="controller"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.controller}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.supervisor && errors.supervisor)}
                                                fullWidth
                                                label="Fiscal Responsável"
                                                margin="none"
                                                id="supervisor"
                                                name="supervisor"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.supervisor}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="occurrenceType" required >Tipo de Ocorrência</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.occurrenceType && errors.occurrenceType)}
                                                    helperText={touched.occurrenceType && errors.occurrenceType}
                                                    value={values.occurrenceType}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Tipo de Ocorrência"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'occurrenceType',
                                                        id: 'occurrenceType',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.occurrenceTypes.map((occurrenceType) => (
                                                        <MenuItem key={occurrenceType.id} value={occurrenceType.id}>{occurrenceType.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="category" required >Categoria da Ocorrência</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.category && errors.category)}
                                                    helperText={touched.category && errors.category}
                                                    value={values.category}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Categoria da Ocorrência"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'category',
                                                        id: 'category',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.categories.map((category) => (
                                                        <MenuItem key={category.id} value={category.id}>{category.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="invoiceType" required >Tipo de Nota</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.invoiceType && errors.invoiceType)}
                                                    helperText={touched.invoiceType && errors.invoiceType}
                                                    value={values.invoiceType}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Tipo de Nota"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'invoiceType',
                                                        id: 'invoiceType',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.invoiceTypes.map((invoiceType) => (
                                                        <MenuItem key={invoiceType.id} value={invoiceType.id}>{invoiceType.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="ocorrenceStatus" required >Fase ATM</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.ocorrenceStatus && errors.ocorrenceStatus)}
                                                    helperText={touched.ocorrenceStatus && errors.ocorrenceStatus}
                                                    value={values.ocorrenceStatus}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Fase ATM"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'ocorrenceStatus',
                                                        id: 'ocorrenceStatus',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.ocorrenceStatusList.map((ocorrenceStatus) => (
                                                        <MenuItem key={ocorrenceStatus.id} value={ocorrenceStatus.id}>{ocorrenceStatus.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="atendType" required >Tipo de Atendimento</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.atendType && errors.atendType)}
                                                    helperText={touched.atendType && errors.atendType}
                                                    value={values.atendType}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Tipo de Atendimento"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'atendType',
                                                        id: 'atendType',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.atendTypes.map((atendType) => (
                                                        <MenuItem key={atendType.id} value={atendType.id}>{atendType.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="companystatus" required >Status Cliente</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.companyStatus && errors.companyStatus)}
                                                    helperText={touched.companyStatus && errors.companyStatus}
                                                    value={values.companyStatus}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Status Cliente"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'companyStatus',
                                                        id: 'companystatus',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.companyStatusList.map((companyStatus) => (
                                                        <MenuItem key={companyStatus.id} value={companyStatus.id}>{companyStatus.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="symptom">Sintoma</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.symptom && errors.symptom)}
                                                    helperText={touched.symptom && errors.symptom}
                                                    value={values.symptom}
                                                    onChange={e => {
                                                        handleSymptom(e, values);
                                                        handleChange(e);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Sintoma"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'symptom',
                                                        id: 'symptom',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.symptomes.map((symptom) => (
                                                        <MenuItem key={symptom.id} value={symptom.id}>
                                                            {getSymptomName(symptom)}
                                                        </MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dateFirstAtend"
                                                label="Limite 1º Atendimento - CPA"
                                                format="DD/MM/YYYY"
                                                name="dateFirstAtend"
                                                value={values.dateFirstAtend}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dateFirstAtend", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dateConclusion"
                                                label="Limite Conclusão - CPC"
                                                format="DD/MM/YYYY"
                                                name="dateConclusion"
                                                value={values.dateConclusion}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dateConclusion", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="symptomLocal">Localização do Sintoma</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.symptomLocal && errors.symptomLocal)}
                                                    helperText={touched.symptomLocal && errors.symptomLocal}
                                                    value={values.symptomLocal}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Localização do Sintoma"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'symptomLocal',
                                                        id: 'symptomLocal',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.symptomLocals.map((symptomLocal) => (
                                                        <MenuItem key={symptomLocal.id} value={symptomLocal.id}>{symptomLocal.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>



                                        <Grid
                                            item
                                            xs={12}
                                        >
                                            <TextField
                                                error={Boolean(touched.description && errors.description)}
                                                fullWidth
                                                helperText="Coloque aqui comentário ou justificativa a respeito da ação escolhida (1024 caracteres)."
                                                label="Descrição da Ocorrência"
                                                rows={6}
                                                size={10}
                                                length={1024}
                                                multiline
                                                margin="none"
                                                name="description"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.description}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
